import { render, staticRenderFns } from "./Review2.vue?vue&type=template&id=4605f3ec&scoped=true&"
import script from "./Review2.vue?vue&type=script&lang=js&"
export * from "./Review2.vue?vue&type=script&lang=js&"
import style0 from "./Review2.vue?vue&type=style&index=0&id=4605f3ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4605f3ec",
  null
  
)

export default component.exports